import { render, staticRenderFns } from "./ProjectsConflicts.vue?vue&type=template&id=48770c2a&"
import script from "./ProjectsConflicts.vue?vue&type=script&lang=js&"
export * from "./ProjectsConflicts.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsConflicts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports